import { Navigate, Route, Routes, useParams } from "react-router-dom";
import { AppShell } from "./components/AppShell";
import { LoginPage } from "./pages/LoginPage";
import { NotFoundPage } from "./pages/NotFoundPage";
import { ProtectedRoute } from "./pages/ProtectedRoute";
import { SessionDetailPage } from "./pages/SessionDetailPage";
import { SessionListPage } from "./pages/SessionListPage";
import { UploadPage } from "./pages/UploadPage";
import { JobPage } from "./pages/JobPage";
import { OrganizationProjectsPage } from "./pages/OrganizationProjectsPage";
import { OrganizationTasksPage } from "./pages/OrganizationTasksPage";
import { OrganizationJobsPage } from "./pages/OrganizationJobsPage";
import { OrganizationSettingsPage } from "./pages/OrganizationSettingsPage";
import { OrganizationsPage } from "./pages/OrganizationsPage";
import { ProjectPage } from "./pages/ProjectPage";
import { TaskPage } from "./pages/TaskPage";
import { InvitationAcceptPage } from "./pages/InvitationAcceptPage";
import { LegacyJobRedirect, LegacyProjectRedirect, LegacySessionRedirect, LegacyTaskRedirect } from "./pages/LegacyRouteRedirect";

export function App() {
  return <Routes>
    <Route path="/login" element={<LoginPage />} />
    <Route path="/invitations/:token" element={<InvitationAcceptPage />} />
    <Route element={<ProtectedRoute />}>
      <Route element={<AppShell />}>
        <Route path="/sessions" element={<SessionListPage />} />
        <Route path="/organizations" element={<OrganizationsPage />} />
        <Route path="/organizations/:organizationId" element={<OrganizationRouteRedirect />} />
        <Route path="/organizations/:organizationId/projects" element={<OrganizationProjectsPage />} />
        <Route path="/organizations/:organizationId/tasks" element={<OrganizationTasksPage />} />
        <Route path="/organizations/:organizationId/jobs" element={<OrganizationJobsPage />} />
        <Route path="/organizations/:organizationId/settings" element={<OrganizationSettingsPage />} />
        <Route path="/organizations/:organizationId/settings/:settingsSection" element={<OrganizationSettingsPage />} />
        <Route path="/organizations/:organizationId/projects/:projectId" element={<ProjectPage />} />
        <Route path="/organizations/:organizationId/projects/:projectId/upload" element={<UploadPage />} />
        <Route path="/organizations/:organizationId/tasks/:taskId" element={<TaskPage />} />
        <Route path="/organizations/:organizationId/jobs/:jobId" element={<JobPage />} />
        <Route path="/organizations/:organizationId/projects/:projectId/sessions/:sessionId" element={<SessionDetailPage />} />
        <Route path="/projects/:projectId" element={<LegacyProjectRedirect />} />
        <Route path="/projects/:projectId/upload" element={<LegacyProjectRedirect upload />} />
        <Route path="/tasks/:taskId" element={<LegacyTaskRedirect />} />
        <Route path="/jobs/:jobId" element={<LegacyJobRedirect />} />
        <Route path="/sessions/:sessionId" element={<LegacySessionRedirect />} />
      </Route>
    </Route>
    <Route path="/" element={<Navigate to="/organizations" replace />} />
    <Route path="*" element={<NotFoundPage />} />
  </Routes>;
}

function OrganizationRouteRedirect() {
  const { organizationId = "" } = useParams();
  return <Navigate to={`/organizations/${organizationId}/projects`} replace />;
}
